import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, vShow as _vShow, createVNode as _createVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, toRefs, inject } from "vue";
import { useStore } from "vuex";
import { Booking } from "@/models";
import moment from "moment-timezone";
import { DxDateRangeBox } from "devextreme-vue/date-range-box";

export default /*#__PURE__*/_defineComponent({
  __name: 'DateRange',
  props: {
    pvm: {},
    changesdaterangepvmid: {}
  },
  emits: ["daterangepvmselected"],
  setup(__props: any, { emit: __emit }) {

const store = useStore();
const actProperty: any = inject("actProperty");
const propertyvisitmanagement = computed(
  () => store.getters["propertyvisitmanagement/getBookingsData"]
);
const props = __props;
const emit = __emit;
const minDate = new Date("2020-01-01"); // Very old date (acts as "infinity" in the past)
const maxDate = new Date("2050-12-31"); // Very distant future date (acts as "infinity" in the future)
const dynamicDateRangeRefs = ref<{ [key: string]: HTMLElement | undefined }>(
  {}
);
const setBookingsData = (data: Booking[]) =>
  store.commit("propertyvisitmanagement/setBookings", data);
const { pvm, changesdaterangepvmid } = toRefs(props);
const changeDateRangeReport = () => {
  emit("daterangepvmselected", pvm.value.id);

  const dropdown = dynamicDateRangeRefs.value[
    `dynamicDateRangeRefs-${pvm.value.id}`
  ] as any;
  if (dropdown) {
    dropdown.activate();
  }
};
const closeDropdown = () => {
  emit("daterangepvmselected", "");
};
const dateRange = ref<[Date | null, Date | null]>([null, null]);
const computedDateRange = computed(
  () => dateRange.value
);
const setScheduledDate = async (id: string, value: any) => {
  if (value[0] && value[1]) {
    dateRange.value = value;
    const pmIndex = propertyvisitmanagement.value.findIndex(
      (r: Booking) => r.id === props.pvm.id
    );
    propertyvisitmanagement.value[pmIndex].daterangestartdate = moment(
      value[0]
    ).format("YYYY-MM-DD[T]HH:mm");
    propertyvisitmanagement.value[pmIndex].daterangeenddate = moment(
      value[1]
    ).format("YYYY-MM-DD[T]HH:mm");
    setBookingsData(propertyvisitmanagement.value);
    pvm.value.id = id;
    emit("daterangepvmselected", "");
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", { onFocusout: closeDropdown }, [
    _withDirectives(_createVNode(_unref(DxDateRangeBox), {
      modelValue: computedDateRange.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((computedDateRange).value = $event)),
      min: _unref(minDate),
      max: _unref(maxDate),
      displayFormat: "dd/MM/yyyy",
      label: "Select Date Range",
      ref: 'dynamicDateRangeRefs-' + _unref(pvm).id,
      onValueChanged: _cache[1] || (_cache[1] = ($event: any) => (setScheduledDate(_unref(pvm).id, $event.value)))
    }, null, 8, ["modelValue", "min", "max"]), [
      [_vShow, _unref(changesdaterangepvmid) === _unref(pvm).id]
    ]),
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass({ 'transparent-text': !_unref(pvm).daterangestartdate }),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (changeDateRangeReport()))
    }, _toDisplayString(_unref(pvm).daterangestartdate && _unref(pvm).daterangeenddate
          ? _unref(actProperty).formatDateForDisplay(_unref(pvm).daterangestartdate) +
            " - " +
            _unref(actProperty).formatDateForDisplay(_unref(pvm).daterangeenddate)
          : "Select"), 3), [
      [_vShow, _unref(changesdaterangepvmid) !== _unref(pvm).id]
    ])
  ], 32))
}
}

})